import styled, { css } from 'styled-components';

export const CheckMark = styled.span<{ disabled?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 1.5rem;
  width: 1.5rem;
  border: 1px solid var(--color-mono-0);
  background-color: var(--color-mono-100);
  border-radius: 2px;
  &:after {
    content: '';
    position: absolute;
    display: none;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      border: 1px solid var(--color-mono-60);
    `}
`;

export const Container = styled.label<{
  partialChecked?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  position: relative;
  padding-left: 32px;
  cursor: pointer;
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  // When Checkbox is hovered and is unchecked
  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover input:not(:checked) ~ ${CheckMark} {
        &:after {
          background-color: var(--color-mono-100);
          left: 9px;
          top: 5px;
          width: 5px;
          height: 10px;
          border: solid var(--color-mono-0);
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
          display: block;
        }
      }
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: auto;
      color: var(--color-mono-60);
    `}

  input:checked ~ ${CheckMark} {
    background-color: var(--color-mono-0);
    &:after {
      display: block;
    }
  }

  // When Checkbox is checked
  ${CheckMark}:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    background-color: black;
    ${({ partialChecked }) =>
      partialChecked &&
      css`
        top: 10px;
        left: 5px;
        transform: none;
        height: 2px;
        width: 12px;
        background-coloe: var(--color-mono-100);
      `}
  }
  &:focus-within {
    outline: var(--focus-style);
    outline-offset: 2px;
  }
`;

export const CheckContainer = styled(Container)`
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 3px;
`;
